export enum ApprovalStatus {
    Draft,
    AwaitingApproval,
    ChangesRequested,
    Approved,
    Rejected,
}

export enum ApprovalEvent {
    ApprovalRequested,
    ApprovalRequestCanceled,
    ChangesRequested,
    Approved,
    Rejected,
}

export interface LLMClassifierApprovalReviewer {
    userId: string;
    displayName: string;
    email?: string;
    userName?: string;
}

export interface LLMClassifierApprovalEventSummary {
    id: string;
    event: ApprovalEvent;
    createdOn: string;
    createdBy?: string;
    createdByName?: string;
    comment?: string;
    comparedToEntityId?: string;
    requestedApprovers: LLMClassifierApprovalReviewer[];
}

export interface RecordLLMClassifierApprovalEventRequest {
    event: ApprovalEvent;
    requestedApproverUserIds?: string[];
    comparedToEntityId?: string;
    comment?: string;
}

export interface LLMClassifierApprovalEmailNotification {
    targetedUserCount: number;
    attemptedAddressCount: number;
    sentAddressCount: number;
    failedAddressCount: number;
    missingAddressUserCount: number;
}

export interface LLMClassifierApprovalMutationResponse {
    notification: LLMClassifierApprovalEmailNotification;
}
